import React from 'react'

export default function NiTool() {
  return (
    <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.68493 9.78082C3.42063 9.57011 2.42989 8.57937 2.21918 7.31507V7.31507C2.07406 6.44436 2.07406 5.55564 2.21918 4.68493V4.68493C2.42989 3.42063 3.42063 2.4299 4.68493 2.21918V2.21918C5.55564 2.07406 6.44436 2.07406 7.31507 2.21918V2.21918C8.57937 2.4299 9.57011 3.42063 9.78082 4.68493V4.68493C9.92594 5.55564 9.92594 6.44436 9.78082 7.31507V7.31507C9.57011 8.57937 8.57937 9.57011 7.31507 9.78082V9.78082C6.44436 9.92594 5.55564 9.92594 4.68493 9.78082V9.78082Z"
            stroke="currentColor"
            stroke-width="1.5"
          ></path>
          <path
            opacity="0.6"
            d="M16.6849 9.78082C15.4206 9.57011 14.4299 8.57937 14.2192 7.31507V7.31507C14.0741 6.44436 14.0741 5.55564 14.2192 4.68493V4.68493C14.4299 3.42063 15.4206 2.4299 16.6849 2.21918V2.21918C17.5556 2.07406 18.4444 2.07406 19.3151 2.21918V2.21918C20.5794 2.4299 21.5701 3.42063 21.7808 4.68493V4.68493C21.9259 5.55564 21.9259 6.44436 21.7808 7.31507V7.31507C21.5701 8.57937 20.5794 9.57011 19.3151 9.78082V9.78082C18.4444 9.92594 17.5556 9.92594 16.6849 9.78082V9.78082Z"
            stroke="currentColor"
            stroke-width="1.5"
          ></path>
          <path
            d="M4.68493 21.7808C3.42063 21.5701 2.42989 20.5794 2.21918 19.3151V19.3151C2.07406 18.4444 2.07406 17.5556 2.21918 16.6849V16.6849C2.42989 15.4206 3.42063 14.4299 4.68493 14.2192V14.2192C5.55564 14.0741 6.44436 14.0741 7.31507 14.2192V14.2192C8.57937 14.4299 9.57011 15.4206 9.78082 16.6849V16.6849C9.92594 17.5556 9.92594 18.4444 9.78082 19.3151V19.3151C9.57011 20.5794 8.57937 21.5701 7.31507 21.7808V21.7808C6.44436 21.9259 5.55564 21.9259 4.68493 21.7808V21.7808Z"
            opacity="0.6"
            stroke="currentColor"
            stroke-width="1.5"
          ></path>
          <path
            d="M16.6849 21.7808C15.4206 21.5701 14.4299 20.5794 14.2192 19.3151V19.3151C14.0741 18.4444 14.0741 17.5556 14.2192 16.6849V16.6849C14.4299 15.4206 15.4206 14.4299 16.6849 14.2192V14.2192C17.5556 14.0741 18.4444 14.0741 19.3151 14.2192V14.2192C20.5794 14.4299 21.5701 15.4206 21.7808 16.6849V16.6849C21.9259 17.5556 21.9259 18.4444 21.7808 19.3151V19.3151C21.5701 20.5794 20.5794 21.5701 19.3151 21.7808V21.7808C18.4444 21.9259 17.5556 21.9259 16.6849 21.7808V21.7808Z"
            stroke="currentColor"
            stroke-width="1.5"
          ></path>
        </svg>
  )
}
